import i18n from "../i18n";
import moment from "moment";
import { getAppLanguageCode, getMomentLocale } from "./appLocale";

export const ft = (key, opts) => i18n.t(`finance:${key}`, opts);

export function getPeriodsEOAF() {
  return [
    { label: ft("eoaf.periodCurrentYear"), value: "currentYear" },
    { label: ft("eoaf.periodLastYear"), value: "lastYear" },
    { label: ft("eoaf.periodLast12"), value: "last12Months" },
    { label: ft("eoaf.periodLast6"), value: "last6Months" },
    { label: ft("eoaf.periodLast3"), value: "last3Months" },
  ];
}

export function getLoadingViewMessage(view) {
  const map = {
    day: "cashflow.loadingDaily",
    week: "cashflow.loadingWeekly",
    month: "cashflow.loadingMonthly",
  };
  return ft(map[view] || "common.loading");
}

export function getLoadingCurrencyMessage(currency) {
  const map = {
    CLP: "cashflow.loadingCLP",
    UF: "cashflow.loadingUF",
    USD: "cashflow.loadingUSD",
    EUR: "cashflow.loadingEUR",
    GBP: "cashflow.loadingGBP",
    MXN: "cashflow.loadingMXN",
    UTM: "cashflow.loadingUTM",
  };
  return ft(map[currency] || "common.loading");
}

export function getLoadingProjectionMessage(on) {
  return ft(on ? "cashflow.addingProjections" : "cashflow.removingProjections");
}

export function getLoadingOnlyEstimationsMessage(on) {
  return ft(on ? "cashflow.onlyEstimationsOn" : "cashflow.onlyEstimationsOff");
}

export function getBitacoraDefaultTitle(date) {
  const code = getAppLanguageCode();
  const loc = getMomentLocale();
  const d = date ? moment(date) : moment();
  const format =
    code === "en"
      ? "MMMM D, YYYY"
      : code === "ja"
        ? "YYYY年M月D日"
        : "D [de] MMMM [de] YYYY";
  const formatted = d.locale(loc).format(format);
  return ft("bitacora.defaultTitle", { date: formatted });
}

export function getCreditTypeLabels() {
  return {
    comercial: ft("loans.typeCommercial"),
    bullet: ft("loans.typeBullet"),
    comex: ft("loans.typeComex"),
    cartaCredito: ft("loans.typeLetterOfCredit"),
    leasing: ft("loans.typeLeasing"),
  };
}
